import { createContext, useContext } from 'react';

/**
 * Context used to allow individual mobile screens to guard swipe-back gestures.
 * Screens can register an async guard function that returns `true` to allow
 * navigation or `false` to cancel it (e.g. to show a confirmation modal).
 */
export const MobileSwipeBackContext = createContext({
  registerSwipeBackGuard: () => () => {}
});

export const useMobileSwipeBackContext = () => useContext(MobileSwipeBackContext);
